// extracted by mini-css-extract-plugin
export var chip = "_qu-0";
export var icon = "_qu-1";
export var remove = "_qu-2";
export var removeIcon = "_qu-3";